// extracted by mini-css-extract-plugin
module.exports = {"footerContainer":"ClientWallet_footerContainer__2Iifu","savePackageButton":"ClientWallet_savePackageButton__3yjmA"};